import React, { Component } from 'react';
import './battery.css';

class Battery extends Component {

  render() {
    return (
      <span className="top-battery">
          <div className="top-battery-icon">
            <div className="top-battery-full"></div>
          </div>
          
      </span>
    );
  }
}

export default Battery;
